import { BreakpointTypes } from "../types/BreakpointTypes";
import { GetDemoVersionModalComponent } from "../components/modals/get-demo-version-modal.component";
import Modal from 'modal-vanilla';

export class WebAppLayout {

  _webAppWrapperEl;
  _demoVersionBtnEl;
  _demoVersionModalEl;

  init() {
    this._webAppWrapperEl = document.querySelector('.web-app-wrapper');

    if (this._webAppWrapperEl) {
      this.afterLayoutRender();
    }
  }

  afterLayoutRender() {
    this.initSuitableAppsSlider();
    this.initOtherAppsSlider();
    this.demoVersionBtnActions();
  }

  demoVersionBtnActions() {
    this._demoVersionBtnEl = this._webAppWrapperEl.querySelector('.start-free-trail-button');
    this._demoVersionModalEl = document.querySelector('#get-demo-version-modal');

    this.openDemoVersionModal();
  }

  openDemoVersionModal() {
    if (this._demoVersionModalEl && this._demoVersionBtnEl) {
      const getDemoVersionModalComponent = new GetDemoVersionModalComponent();
      getDemoVersionModalComponent.init();

      this._demoVersionBtnEl.addEventListener('click', () => {
        this._applyForJobModalInstance = new Modal({
          el: this._demoVersionModalEl
        }).show();

        this._applyForJobModalInstance.on('dismiss', function(myModal, event) {
          if (getDemoVersionModalComponent.formSent) {
            getDemoVersionModalComponent.reload();
          }
        });
      });
    }
  }

  initSuitableAppsSlider() {
    const sliderWrapper = this._webAppWrapperEl.querySelector('.web-app-wrapper__suitable-apps__slider');
    const sliderInnerWrapper = sliderWrapper.querySelector('.web-app-wrapper__suitable-apps__slider__inner');
    const sliderArrowsWrapper = this._webAppWrapperEl.querySelector('.web-app-wrapper__suitable-apps__slider-arrows');
    const slidesCount = +sliderInnerWrapper.getAttribute('data-slides-count');
    const [leftArrow, rightArrow] = sliderArrowsWrapper.querySelectorAll('.arrow-left, .arrow-right');
    const [currentPageEl, pagesCountEl] = sliderArrowsWrapper.querySelectorAll('.pages__current, .pages__count');
    const pagesCount = Math.ceil(slidesCount / 2);

    const slide = (currentPageFactor) => {
      currentPage += currentPageFactor;
      currentPageEl.textContent = (currentPage + 1).toString();
      sliderInnerWrapper.style.transform = `translateX(calc(-${ currentPage * 100 }% - ${ 35 * currentPage }px))`;
    };

    const setStylesAccordingToDeviceWidth = () => {
      if (window.innerWidth > BreakpointTypes.l - 1) {
        sliderArrowsWrapper.classList.add('d-flex');
        sliderWrapper.scrollLeft = 0;
      } else {
        sliderArrowsWrapper.classList.remove('d-flex');
        sliderInnerWrapper.style.transform = 'unset';
        currentPage = 0;
        currentPageEl.textContent = (currentPage + 1).toString();
      }
    };

    let currentPage = 0;

    if (slidesCount < 3) {
      sliderArrowsWrapper.remove();
    } else {

      window.addEventListener('resize', setStylesAccordingToDeviceWidth);

      setStylesAccordingToDeviceWidth();

      pagesCountEl.textContent = pagesCount.toString();

      this.blockHorizontalScrolling(sliderWrapper, BreakpointTypes.l - 1);

      leftArrow.addEventListener('click', () => {
        if (currentPage > 0) {
          slide(-1);
        }
      });

      rightArrow.addEventListener('click', () => {
        if (currentPage + 1 < pagesCount) {
          slide(1);
        }
      });
    }
  }

  initOtherAppsSlider() {
    const sliderWrapper = this._webAppWrapperEl.querySelector('.web-app-wrapper__other-apps__slider-wrapper');
    const sliderWrapperSlider = sliderWrapper.querySelector('.web-app-wrapper__other-apps__slider-wrapper__slider');
    const slideEl = sliderWrapper.querySelector(`.web-app-wrapper__other-apps__slider-wrapper__slider__inner__slide[data-pathname="${ location.pathname }"]`);

    if (slideEl) {
      slideEl.remove();
    }

    const sliderInnerWrapper = sliderWrapper.querySelector(
      '.web-app-wrapper__other-apps__slider-wrapper__slider__inner'
    );
    const [leftArrow, rightArrow] = sliderWrapper.querySelectorAll('.arrow-left, .arrow-right');
    const slidesCount = +sliderInnerWrapper.getAttribute('data-slides-count') - 1;
    const slideMarginRight = +getComputedStyle(
      sliderInnerWrapper.firstElementChild
    ).marginRight.replace('px', '');
    const slideWidth = sliderInnerWrapper.firstElementChild.offsetWidth + slideMarginRight;

    const slide = (slideFactor) => {
      translateVal += (slideWidth * slideFactor);
      sliderInnerWrapper.style.transform = `translateX(${ translateVal }px)`;
    };

    const setStylesAccordingToDeviceWidth = () => {
      if (window.innerWidth > BreakpointTypes.s - 1) {
        sliderWrapperSlider.scrollLeft = 0;
      } else {
        translateVal = 0;
        sliderInnerWrapper.style.transform = `translateX(0)`;
      }
    };

    let translateVal = 0;

    setStylesAccordingToDeviceWidth();

    window.addEventListener('resize', setStylesAccordingToDeviceWidth);

    leftArrow.addEventListener('click', () => {
      if (translateVal < 0) {
        slide(1);
      }
    });

    rightArrow.addEventListener('click', () => {
      if (translateVal > (sliderInnerWrapper.offsetWidth - (slidesCount * slideWidth))) {
        slide(-1);
      }
    });

    this.blockHorizontalScrolling(sliderWrapper, BreakpointTypes.s - 1);
  }

  blockHorizontalScrolling(el, breakpoint) {
    el.addEventListener('wheel', e => {
      if ((window.innerWidth > breakpoint) && e.wheelDeltaX !== 0) {
        e.preventDefault();
      }
    });
  }
}
